import { render, staticRenderFns } from "./RiseupGoal.vue?vue&type=template&id=1eeca06c&scoped=true&"
import script from "./RiseupGoal.vue?vue&type=script&lang=js&"
export * from "./RiseupGoal.vue?vue&type=script&lang=js&"
import style0 from "./RiseupGoal.vue?vue&type=style&index=0&id=1eeca06c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eeca06c",
  null
  
)

export default component.exports